// extracted by mini-css-extract-plugin
module.exports = {"card":"FareCard-desktop-module__card___2zSma","popoverTrigger":"FareCard-desktop-module__popoverTrigger___17Vgm"};